import React, { Component } from "react";
import { Spin, Modal } from "antd";
import {
  showSuccessNotification,
  showErrorNotification,
  strings,
  getProp
} from "../../helpers";
import UsersDetailsView from "./UsersDetailsView";

import {
  getUserDetails,
  getBillingDetails,
  updateUserFlags,
  getUserDevices,
  deleteDevice,
  deleteBulkDevices
} from "../../services";
import UserSubscriptionModal from "./UserSubscriptionModal";
import moment from "moment";

export default class UsersDetailsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userDetails: {},
      userSubscription: [],
      isProcessing: false,
      userPayments: [],
      userStatus: "",
      showAddSubscriptionModal: false,
      devices: [],
      fetchingDevices: false,
      userid: null,
      devicePageNo: 1,
      totalDevicePages: 0,
      allDevices: 0,
      deviceType: "all"
    };
  }

  componentDidMount() {
    const { userid } = this.props.match.params;
    this.setState({ userid });
    this.fetchUsersDetails(userid);
    this.fetchUserDevices(userid);
  }

  fetchUserDevices = userId => {
    const { devicePageNo, deviceType } = this.state;
    this.setState({ fetchingDevices: true });
    getUserDevices(userId, devicePageNo, deviceType)
      .then(response => {
        if (response?.data?.success) {
          this.setState({
            devices: response?.data?.data?.devices,
            allDevices: response?.data?.data?.total_records
          });
        }
      })
      .finally(() => {
        this.setState({ fetchingDevices: false });
      });
  };

  /**
   * @function fetchBillingDetails
   * @description This function will fetch user billing details
   */
  fetchBillingDetails = userId => {
    this.setState({
      isProcessing: true
    });
    getBillingDetails(userId)
      .then(response => {
        const getBillingDetail = getProp(["data", "data", "payments"]);

        this.setState({
          isProcessing: false
        });
        if (response.data.success) {
          const userPayments = getBillingDetail(response);
          this.setState({ userPayments });
        } else {
          this.setState({
            userPayments: []
          });
        }
      })
      .catch(() => {
        showErrorNotification(strings.error_msg);
        this.setState({ userPayments: [], isProcessing: false });
      });
  };

  /**
   * @function fetchUsersDetails
   * @description This function get doctors data
   */
  fetchUsersDetails = userId => {
    this.setState({
      isProcessing: true
    });
    getUserDetails(userId)
      .then(response => {
        const getUser = getProp(["data", "data", "user"]);
        const getSubscription = getProp(["data", "data", "subscriptions"]);

        this.setState({
          isProcessing: false
        });
        if (response.data.success) {
          const userDetails = getUser(response);
          const userSubscription = getSubscription(response);

          this.setState(
            {
              userDetails,
              userSubscription
            },
            () => this.fetchBillingDetails(userId)
          );
        } else {
          this.setState({
            userDetails: {},
            userSubscription: [],
            isProcessing: false
          });
        }
      })
      .catch(() => {
        showErrorNotification(strings.error_msg);
        this.setState({ usersList: [], isProcessing: false });
      });
  };

  /**
   * @function navigateToDoctorDetails.
   * @desc it will navigate the user to new tab with details.
   */
  navigateToDoctorDetails = (recordType, id) => {
    let url = "";

    if (recordType === "clinic") {
      url = `/clinics-details/${id}/basic-details`;
    } else if (recordType === "lab") {
      url = `/lab-details/${id}/basic-details`;
    } else if (recordType === "doctor") {
      url = `/doctor-details/${id}/basic-details`;
    } else if (recordType === "pharmacy") {
      url = `/pharmacy-details/${id}/basic-details`;
    }
    return url;
  };

  /**
   * @function toggleSubscriptionModal
   * @description it will handle user status and hit api.
   */
  handleUserStatus = value => {
    const { userDetails } = this.state;
    this.setState({ userStatus: value });
    this.toggleIsProcessing();
    const data = {};
    data.user_status = value;
    updateUserFlags(data, userDetails.id)
      .then(response => {
        if (response.data.success) {
          const successMsg = response.data.message;
          showSuccessNotification(successMsg);
          const { userid } = this.props.match.params;
          this.fetchUsersDetails(userid);
        } else {
          const { errors } = response.data.error;
          let error = errors;
          showErrorNotification(error);
        }
        this.stopIsProcessing();
      })
      .catch(response => {
        const getErrors = getProp(["data", "errors"]);
        if (getErrors(response)) {
          const { errors } = response.data;
          let error = errors;
          if (Array.isArray(errors)) {
            error = errors[0];
          }
          showErrorNotification(error.title);
        }
      });
  };

  /**
   * @function toggleSubscriptionModal
   * @description it will toggle the manual subscription modal.
   */
  toggleSubscriptionModal = () => {
    const { showAddSubscriptionModal } = this.state;
    this.setState({ showAddSubscriptionModal: !showAddSubscriptionModal });
  };

  /**
   * @function toggleIsProcessing
   * @description it will change the processing.
   */
  toggleIsProcessing = () => {
    const { isProcessing } = this.state;
    this.setState({ isProcessing: !isProcessing });
  };

  /**
   * @function stopIsProcessing
   * @description it will change the processing.
   */
  stopIsProcessing = () => {
    this.setState({ isProcessing: false });
  };

  handleDeletionConfirmation = () => {
    Modal.info({
      title: `Delete All SNS`,
      content: <div>Are you sure you want to delete SNS from all devices?</div>,
      onOk: () => {
        this.handleBulkDeviceDeletion();
      }
    });
  };

  handleBulkDeviceDeletion = () => {
    const { userid, deviceType } = this.state;
    if (userid) {
      this.setState({ isProcessing: true });
      deleteBulkDevices(userid, deviceType)
        .then(response => {
          if (response?.data?.success) {
            this.setState({ devicePageNo: 1 }, () => {
              this.fetchUserDevices(userid);
            });
            showSuccessNotification("Devices deleted successfully");
          } else {
            showErrorNotification(strings.schedule.serverError);
          }
        })
        .finally(() => {
          this.setState({ isProcessing: false });
        })
        .catch(() => {
          showErrorNotification(strings.schedule.serverError);
        });
    }
  };

  handleShowDeviceDetail = (e, deviceObj) => {
    if (e) e.preventDefault();
    Modal.info({
      title: "Device detail",
      content: (
        <ul className="device_list">
          {Object.keys(deviceObj).map(key => {
            return (
              <li key={key}>
                <b className="pr-5">{key}:</b>
                {key === "created_at" || key === "updated_at"
                  ? moment(deviceObj[key]).format("DD MMM, YYYY")
                  : deviceObj[key] || "--"}
              </li>
            );
          })}
        </ul>
      ),
      onOk() {}
    });
  };

  handleDeleteSNSToken = (e, deviceObj) => {
    if (e) e.preventDefault();
    Modal.info({
      title: `Delete SNS`,
      content: <div>Are you sure you want to this SNS?</div>,
      onOk: () => {
        this.handleDeviceDeletion(deviceObj);
      }
    });
  };

  handleDeviceDeletion = deviceObj => {
    const { userid } = this.state;
    if (userid && deviceObj) {
      this.setState({ isProcessing: true });
      deleteDevice(userid, deviceObj.id)
        .then(response => {
          if (response?.data?.success) {
            this.setState({ devicePageNo: 1 }, () => {
              this.fetchUserDevices(userid);
            });
            showSuccessNotification("Device deleted successfully");
          } else {
            showErrorNotification(strings.schedule.serverError);
          }
        })
        .finally(() => {
          this.setState({ isProcessing: false });
        })
        .catch(() => {
          showErrorNotification(strings.schedule.serverError);
        });
    }
  };

  onDevicesPageChange = page => {
    const { userid } = this.state;
    this.setState({ devicePageNo: page, devices: [] }, () => {
      this.fetchUserDevices(userid);
    });
  };

  handleDeviceChange = val => {
    const { userid } = this.state;
    this.setState({ deviceType: val }, () => {
      this.fetchUserDevices(userid);
    });
  };

  render() {
    const {
      isProcessing,
      userDetails,
      userSubscription,
      userPayments,
      userStatus,
      showAddSubscriptionModal,
      fetchingDevices,
      devices,
      allDevices,
      devicePageNo,
      totalDevicePages,
      deviceType
    } = this.state;

    return (
      <Spin spinning={isProcessing}>
        <UsersDetailsView
          navigateToDoctorDetails={this.navigateToDoctorDetails}
          userDetails={userDetails}
          userSubscription={userSubscription}
          userPayments={userPayments}
          handleUserStatus={this.handleUserStatus}
          userStatus={userStatus}
          showAddSubscriptionModal={showAddSubscriptionModal}
          toggleSubscriptionModal={this.toggleSubscriptionModal}
          handleSNSDeletion={this.handleSNSDeletion}
          fetchingDevices={fetchingDevices}
          devices={devices}
          handleShowDeviceDetail={this.handleShowDeviceDetail}
          handleDeleteSNSToken={this.handleDeleteSNSToken}
          allDevices={allDevices}
          devicePageNo={devicePageNo}
          totalDevicePages={totalDevicePages}
          onDevicesPageChange={this.onDevicesPageChange}
          deviceType={deviceType}
          handleDeviceChange={this.handleDeviceChange}
        />

        <UserSubscriptionModal
          showAddSubscriptionModal={showAddSubscriptionModal}
          toggleSubscriptionModal={this.toggleSubscriptionModal}
          isProcessing={isProcessing}
          userDetails={userDetails}
          toggleIsProcessing={this.toggleIsProcessing}
          stopIsProcessing={this.stopIsProcessing}
          fetchUsersDetails={this.fetchUsersDetails}
        />
      </Spin>
    );
  }
}
